import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { CardGroup } from 'react-bootstrap';
import { ProgressSpinner } from '../progress-spinner/component.js';
import { Card } from '../../core/components/Card/card.js';
import { CardBody } from '../../core/components/Card/card-body.js';
/** renders a mobile friendly view of a table list of data as an accordion */

var MobileAccordion = /*#__PURE__*/function (_React$Component) {
  function MobileAccordion(props) {
    var _this;

    _classCallCheck(this, MobileAccordion);

    _this = _callSuper(this, MobileAccordion, [props]);

    _defineProperty(_this, "renderFields", function (dataRow, fields, titleField) {
      return fields.map(function (field) {
        if (field.name === titleField) {
          return null;
        } else if (field.mobileFormatter) {
          return /*#__PURE__*/React.createElement("div", {
            key: dataRow.id + field.name
          }, field.mobileFormatter(dataRow[field.name], dataRow), /*#__PURE__*/React.createElement("br", null));
        } else if (field.formatter) {
          return /*#__PURE__*/React.createElement("div", {
            key: dataRow.id + field.name
          }, field.title, ": ", field.formatter(dataRow[field.name], dataRow), /*#__PURE__*/React.createElement("br", null));
        } else {
          return /*#__PURE__*/React.createElement("div", {
            key: dataRow.id + field.name
          }, field.title, ": ", dataRow[field.name], /*#__PURE__*/React.createElement("br", null));
        }
      });
    });

    _defineProperty(_this, "renderRows", function (data, fields) {
      var _this$props = _this.props,
          className = _this$props.className,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? {} : _this$props$options;
      var mobileTitleField = options.mobileTitleField,
          onRowClick = options.onRowClick;
      return data.map(function (dataRow) {
        var titleField = mobileTitleField || fields[0].name;
        return /*#__PURE__*/React.createElement(Card, {
          variant: "outline",
          key: dataRow.id,
          className: "mobile-accordion-data-list ".concat(className),
          eventKey: dataRow.id
        }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("h5", null, dataRow[titleField]), _this.renderFields(dataRow, fields, titleField), onRowClick && /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(e) {
            return onRowClick(e, dataRow);
          }
        }, "View")));
      });
    });

    _defineProperty(_this, "handleSelect", function (activeKey) {
      _this.setState({
        activeKey: activeKey
      });
    });

    _this.state = {};
    return _this;
  }

  _inherits(MobileAccordion, _React$Component);

  return _createClass(MobileAccordion, [{
    key: "render",
    value: function render() {
      var isLoadingData = this.props.isLoadingData;

      if (isLoadingData) {
        return /*#__PURE__*/React.createElement(ProgressSpinner, {
          containerClassName: "everfi-list-loader"
        });
      } else {
        return /*#__PURE__*/React.createElement(CardGroup, {
          accordion: true,
          id: "mobile-accordion",
          activeKey: this.state.activeKey,
          onSelect: this.handleSelect
        }, this.renderRows(this.props.data, this.props.fields));
      }
    }
  }]);
}(React.Component);

_defineProperty(MobileAccordion, "propTypes", {
  /** adds additional className to each row's panel */
  className: PropTypes.string,

  /** array of data that will be rendered in he table */
  data: PropTypes.array.isRequired,

  /** define how the row data is rendered */
  fields: PropTypes.arrayOf(PropTypes.shape({
    /** overrides what is rendered as cell content
     *  (affects buth table and mobile version) */
    formatter: PropTypes.func,

    /** overrides what is rendered as cell content
     *  (only affects mobile version) */
    mobileFormatter: PropTypes.func,

    /** renders this row attribute as cell text */
    name: PropTypes.string,

    /** defines the column header */
    title: PropTypes.string
  })).isRequired,

  /** set to true when you want to display a loading icon */
  isLoadingData: PropTypes.bool,
  options: PropTypes.shape({
    /** use this attribute to render the row's title
     *  otherwise it uses the first field's name attribute */
    mobileTitleField: PropTypes.string,

    /** callback(event, row) when a row is clicked */
    onRowClick: PropTypes.func
  })
});

MobileAccordion.displayName = "MobileAccordion";
export { MobileAccordion };